// extracted by mini-css-extract-plugin
export default {"root":"style_root__0Uoq2","popup":"style_popup__iviTf","avatar":"style_avatar__qPEzG"};